import { render } from "./StoreCoupons.vue?vue&type=template&id=4e394aa6&scoped=true"
import script from "./StoreCoupons.vue?vue&type=script&lang=js"
export * from "./StoreCoupons.vue?vue&type=script&lang=js"

import "./StoreCoupons.vue?vue&type=style&index=0&id=4e394aa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e394aa6"]])

export default __exports__